/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateHouseholdPersonRequest } from '../models/CreateHouseholdPersonRequest';
import type { HouseholdAndPerson } from '../models/HouseholdAndPerson';
import type { HouseholdPerson } from '../models/HouseholdPerson';
import type { HouseholdsAndPersons } from '../models/HouseholdsAndPersons';
import type { OpenApiInteger } from '../models/OpenApiInteger';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class HouseholdsService {

    /**
     * @param householdId
     * @param id
     * @returns any Success
     * @throws ApiError
     */
    public static deleteHouseholdPerson(
        householdId: OpenApiInteger,
        id: OpenApiInteger,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/households/{householdId}/household-persons/{id}',
            path: {
                'householdId': householdId,
                'id': id,
            },
        });
    }

    /**
     * @param householdId
     * @param requestBody
     * @returns HouseholdPerson Success
     * @throws ApiError
     */
    public static createHouseholdPerson(
        householdId: OpenApiInteger,
        requestBody: CreateHouseholdPersonRequest,
    ): CancelablePromise<HouseholdPerson> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/households/{householdId}/household-persons',
            path: {
                'householdId': householdId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation Error`,
            },
        });
    }

    /**
     * @returns HouseholdsAndPersons Success
     * @throws ApiError
     */
    public static getHouseholdsAndPersons(): CancelablePromise<HouseholdsAndPersons> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/households-and-persons',
        });
    }

    /**
     * @param requestBody
     * @returns HouseholdAndPerson Success
     * @throws ApiError
     */
    public static createHouseholdAndPerson(
        requestBody: CreateHouseholdPersonRequest,
    ): CancelablePromise<HouseholdAndPerson> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/households-and-persons',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation Error`,
            },
        });
    }

}
